import Model from '@/models/Model.js';

export default class Media extends Model {
    static entity = 'medias';

    static fields() {
        return {
            id: this.attr(null),
            model_type: this.string(''),
            model_id: this.attr(null),
            uuid: this.string(''),
            public_url: this.string(''),
            collection_name: this.string(''),
            name: this.string(''),
            file_name: this.string(''),
            mime_type: this.string(''),
            disk: this.string(''),
            conversions_disk: this.string(''),
            size: this.number(0),
            manipulations: this.string(''),
            custom_properties: this.string(''),
            responsive_images: this.string(''),
            order_column: this.number(1),

            deleted_at: this.string(''),
            created_at: this.string(''),
            updated_at: this.string(''),
        };
    }

    static async deleteModel(uri, modelId, mediaId) {
        await this.store().dispatch('AutoSave/setSaving', 'entities/medias');

        const { response } = await this.api().delete(`api/${uri}/${modelId}/media`, {
            data: {
                delete_media: [mediaId],
            },
            save: false,
        });

        if (response.status) {
            await Media.delete(mediaId);
        }

        await this.store().dispatch('AutoSave/setSaved', 'entities/medias');

        return response.data;
    }

    static async updateModel(uri, modelId, mediaId, payload) {
        await this.store().dispatch('AutoSave/setSaving', 'entities/medias');

        const { response } = await this.api().put(`api/${uri}/${modelId}/update-media`, {
            data: {
                mediaId: [mediaId],
                payload,
            },
            save: false,
        });

        await this.store().dispatch('AutoSave/setSaved', 'entities/medias');

        return response.data;
    }
}
